import React, { forwardRef, useState } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputRightElement,
  InputGroup,
  InputLeftElement,
  Input as ChakraInput,
  Image,
} from "@chakra-ui/react";
import { iconEye, iconEyeSlash, iconPassword } from "../../assets/new-images/icons";

const InputPassword = forwardRef(
  (
    {
      name,
      label = "Senha",
      error = null,
      placeholder = "Informe sua senha",
      ...rest
    },
    ref
  ) => {
    const [passwordType, setPasswordType] = useState(true);
    const icon = passwordType ? iconEyeSlash : iconEye;

    return (
      <FormControl isInvalid={!!error}>
        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}

        <InputGroup>
          <InputLeftElement height="full" pl="16px">
            <Image src={iconPassword} alt="padlock icon" w="18px" height="20px" />
          </InputLeftElement>

          <ChakraInput
            name={name}
            id={name}
            placeholder={placeholder}
            ref={ref}
            type={passwordType ? "password" : "text"}
            height="48px"
            fontSize="sm"
            fontWeight={600}
            pl="50px"
            border="1px solid #F5F5FB"
            bg="#F5F5FB"
            borderRadius="8px"
            color="#292B30"
            _placeholderShown={{
              bg: "white",
              borderColor: "#CCCFD1",
            }}
            _disabled={{
              bg: "gray.200",
              color: "rgba(92, 96, 102, 0.3)",
            }}
            {...rest}
          />

          <InputRightElement
            height="full"
            pr="16px"
            onClick={() => setPasswordType(!passwordType)}
            cursor="pointer"
          >
            <Image src={icon} alt="password visibility" />
          </InputRightElement>
        </InputGroup>

        {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
      </FormControl>
    );
  }
);

InputPassword.displayName = "InputPassword";

export default InputPassword;
